import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import axios from "axios";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useCallback, useEffect, useState } from "react";
// import { useClikkle } from "../../context/ClikkleContext";
import { useTheme } from "@emotion/react";
import { useUserProfile } from "../../context/UserProfileContext";
import { useUser } from "../../hooks/Authorize";

function StorageFullPopupDialog({
  isSpaceFull100ModalOpen = false,
  setIsSpaceFull100ModalOpen = () => {},
  isSpaceFull100 = false,
  is100Full = false,
  isUnlimited,
  noOfAllowed,
  format,
  dialogLoading = false,
}) {
  const { mode } = useTheme();
  const platformUser = JSON.parse(localStorage.getItem("user"));
  const { fsUserProfile, setFsUserProfile } = useUserProfile();
  const [userTotalSpacePlan, setUserTotalSpacePlan] = useState(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(false);

  const getFsUserProfile = useCallback(async () => {
    try {
      setIsLoadingProfile(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/user/${platformUser._id}`
      );
      setFsUserProfile(response.data);
      console.log("setFsUserProfile = ", response.data);
    } catch (error) {
      console.error("Profile Fetch Error:", error);
    } finally {
      setIsLoadingProfile(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkSubscriptionDetails = useCallback(async () => {
    try {
      setIsLoadingSubscription(true);
      const response = await axios.get(
        `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/subscription/${platformUser._id}`
      );

      const data = response.data;
      
      setUserTotalSpacePlan(data?.permissions);
    } catch (error) {
      console.log("API Error:", error?.response?.data);
    } finally {
      setIsLoadingSubscription(false);
    }
  }, [platformUser._id]);

  //   const isLoading = isLoadingProfile || isLoadingSubscription;

  useEffect(() => {
    getFsUserProfile();
    checkSubscriptionDetails();
  }, [getFsUserProfile, checkSubscriptionDetails]);

  const handleBuyStorage = () => {
    const redirectUrl = process.env.REACT_APP_STORE_REDIRECT_URL;
    if (redirectUrl) {
      window.open(redirectUrl, "_blank");
    } else {
      console.error("Redirect URL not defined");
    }
  };
  console.log('here');
   console.log(isSpaceFull100ModalOpen,isSpaceFull100);
  return (
    <Modal
      open={isSpaceFull100ModalOpen && isSpaceFull100}
      onClose={() => setIsSpaceFull100ModalOpen(false)}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Full viewport height for vertical centering
          px: "1rem", // Add padding instead of margin for responsiveness
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 500,
            bgcolor: mode === "dark" ? "#121212" : "#D32F2F",
            color: "#fff",
            p: 4,
            borderRadius: 2,
            boxShadow: 3,
            position: "relative",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={() => setIsSpaceFull100ModalOpen(false)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Content */}
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <WarningAmberRoundedIcon
              sx={{ fontSize: 64, mt: 0.5, color: "#FFD600" }}
            />
            <Box flex={1}>
              <Typography sx={{ mt: 1, color: "#fff" }}>
                <strong>Storage Full:</strong>{" "}
                {isUnlimited ? (
                  "You are on an unlimited storage plan. This alert shouldn't appear. Please contact support."
                ) : (
                  <>
                    You’ve used all of your {noOfAllowed}
                    {format} individual storage. To upload more files, free up
                    space or contact your administrator.
                  </>
                )}
              </Typography>

              <Stack
                direction="row"
                spacing={2}
                justifyContent="flex-end"
                sx={{ mt: 3 }}
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#fddddd",
                    color: "#D32F2F",
                    "&:hover": {
                      backgroundColor: "#b71c1c",
                      color: "#ffffff",
                    },
                  }}
                  onClick={handleBuyStorage}
                >
                  Buy Storage
                </Button>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
}

export default StorageFullPopupDialog;
